<template src="@/components/Ork/OrkRecaptcha.html"/>
<style lang="scss" scoped src="@/components/Ork/OrkRecaptcha.scss"/>

<script>

import { SfButton, SfNotification } from '@storefront-ui/vue';
import { configuration } from '@/config/InstanceConfiguration';

export default {
  name: 'OrkRecaptcha',
  props: {
    formId: {
      default: "form",
      type: String
    }
  },
  components: {
    SfButton,
    SfNotification
  },
  computed: {
    consentedToRecaptcha() {
      return !!this.$cookies.get('axeptio_cookies')?.google_recaptcha
    },
    axeptioSDK() { return window.axeptioSDK },
    showCaptchaNotice() { return configuration.forms.captcha.showNotice; }
  },
  methods: {
    changeRecaptchaConsent() {
      this.axeptioSDK?.requestConsent('google_recaptcha')
    },
    execute() {
      const that = this
      window.grecaptcha?.ready(function() {
        window.grecaptcha.execute(window.orkVars.grecaptcha_sitekey, {action: this.formId})
          .then(function(token) {
            that.$emit('verify', token)
          })
      })
    }
  }
}
</script>